import React from "react";

import TypographyComponent from "@/components/Typography";

export const Typography: React.FC<TypographyProps> = ({
  variant,
  fontFamily,
  isExtraBold,
  fontSize,
  lineHeight,
  letterSpacing,
  link1Color,
  link2Color,
  mb = "0px",
  ...rest
}) => {
  const headingProps = {
    fontFamily: fontFamily || "var(--font-700)",
    variant,
    lineHeight,
    letterSpacing,
    mb: mb,
  };

  const headingTypography = {
    heading1: {
      ...headingProps,
      fontSize: fontSize || ["20px", "25px", "30px"],
    },
    heading2: {
      ...headingProps,
      fontSize: fontSize || ["20px", "23px", "26px"],
    },
    title1: {
      ...headingProps,
      fontSize: fontSize || ["16px", "18px", "20px"],
    },
    title2: {
      ...headingProps,
      fontSize: fontSize || ["12px", "14px", "16px"],
    },
    title3: {
      ...headingProps,
      fontSize: fontSize || ["10px", "10px", "12px"],
    },
    title4: {
      ...headingProps,
      fontSize: fontSize || "9px",
    },
  };

  const paragraphProps = {
    fontFamily: fontFamily || "var(--font-500)",
    variant,
    lineHeight,
    letterSpacing,
    mb: mb,
  };

  const paragraphTypography = {
    paragraph1: {
      ...paragraphProps,
      fontSize: fontSize || ["16px", "18px", "18px"],
    },
    paragraph2: {
      ...paragraphProps,
      fontSize: fontSize || ["12px", "14px", "16px"],
    },
    paragraph3: {
      ...paragraphProps,
      fontSize: fontSize || ["12px", "11px", "13px"],
    },
    paragraph4: {
      ...paragraphProps,
      fontSize: fontSize || ["12px", "12px", "12px"],
    },
  };

  const displayProps = {
    fontFamily: fontFamily || "var(--font-500)",
    variant,
    lineHeight,
    letterSpacing,
    mb: mb,
  };

  const displayTypography = {
    header3: {
      ...displayProps,
      fontSize: fontSize || ["17px", "19px", "21px"],
    },
  };

  const spanProps = {
    fontFamily,
    variant,
    letterSpacing,
    lineHeight,
    mb: mb,
  };

  const spanTypography = {
    span: {
      ...spanProps,
      fontSize: fontSize || "12px",
    },
  };

  const linkProps = {
    fontFamily: fontFamily || "var(--font-600)",
    variant,
    lineHeight,
    letterSpacing,
    mb: mb,
  };

  const linkTypography = {
    link1: {
      ...linkProps,
      color: link1Color,
      fontSize: fontSize || ["10px", "10px", "15px"],
    },
    link2: {
      ...linkProps,
      color: link2Color,
      fontSize: fontSize || ["10px", "10px", "14px"],
    },
    routelink1: {
      ...linkProps,
      color: link1Color,
      fontSize: fontSize || ["10px", "10px", "15px"],
    },
    routelink2: {
      ...linkProps,
      color: link2Color,
      fontSize: fontSize || ["10px", "10px", "14px"],
    },
  };

  const typographyV1 = {
    ...headingTypography,
    ...paragraphTypography,
    ...displayTypography,
    ...spanTypography,
    ...linkTypography,
  };

  const typographyProps = {
    ...rest,
    ...typographyV1[variant as keyof typeof typographyV1],
  };

  return <TypographyComponent {...typographyProps} />;
};

export default Typography;
